import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { BoxShadow } from '@r1-frontend/ui-react/tokens/boxShadow';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

const InputPhone = phoneDecorator(InputSimple);
const InputName = nameDecorator(InputSimple);

export const Wrapper = styled.form`
    height: 100%;
    width: 100%;
    padding: 32px;
    background: ${COLORS.BgMain};
    box-shadow: ${BoxShadow.L};
    border-radius: ${BorderRadius.OuterBlockRadius};
`;

export const Title = styled.h2`
    ${FONTS.H3};
    margin-right: 46px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
        margin-right: 32px;
    }
`;

export const Inputs = styled.div`
    display: flex;
    grid-gap: 12px;
    align-items: flex-start;
    margin-bottom: 8px;
    margin-top: 16px;
    width: 100%;
    flex-wrap: nowrap;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 16px;
        flex-wrap: wrap;
    }
`;

export const Name = styled(InputName)`
    display: block;
    max-width: auto;
    margin-bottom: 0;

    @media (max-width: 530px) {
        width: 100%;
    }
`;

export const Phone = styled(InputPhone)`
    display: block;
    max-width: auto;
    margin-bottom: 0;

    @media (max-width: 530px) {
        width: 100%;
    }
`;

export const ButtonBlock = styled.div`
    display: flex;
    grid-gap: 12px;
    flex-wrap: nowrap;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 16px;
        flex-wrap: wrap;
    }
`;

export const OrAuth = styled.div`
    column-gap: 12px;
    & > a {
        color: ${COLORS.Link};
        transition: 0.3s;

        &:hover {
            color: ${COLORS.Brand_Blue};
        }
    }
`;

export const Agree = styled.div`
    display: block;
    max-width: 300px;
    margin-bottom: 16px;

    a {
        display: inline-block;
        border-bottom: 1px solid ${p => p.textColor ? p.textColor : COLORS.black};
        color: ${p => p.textColor ? p.textColor : COLORS.black};
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: calc(100% - 254px);
    }

    @media screen and (max-width: 859px) {
        width: 100%;
        padding-left: 0;
    }
`;

export const Button = styled(BaseButton)`
    flex: 1 0 auto;
    max-width: 180px;

    @media screen and (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        max-width: 100%;
    }
`;

export const Message = styled.div`
    display: block;
    width: 100%;
    ${FONTS.XXL};

    p {
        margin: 15px 0;
    }

    a {
        ${FONTS.Medium};
        color: ${COLORS.lightBlue};
    }
`;
